<template>
  <div>
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <CRow class="align-items-center">
          <CCol md="8">
            <h1 class="h4 mb-1 font-weight-bold">Machine learning data</h1>
            <p class="text-muted mb-0">Download the bill data set used for training</p>
          </CCol>
          <CCol md="4" class="d-flex justify-content-md-end mt-3 mt-md-0">
            <CButton color="primary" :disabled="downloading" @click="onSubmit">
              <CIcon name="cil-cloud-download" /> Download
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import BillApi from "@/lib/billApi";

export default {
  name: "MlDownload",
  data: () => {
    return {
      billApi: new BillApi(),
      downloading: false,
    };
  },
  methods: {
    onSubmit() {
      this.downloading = true;
      this.billApi
        .getBillDataSet()
        .then(() => {
          this.$toast.success("Data set downloaded");
        })
        .catch((error) => {
          console.error(error);
          this.$toast.error("Couldn't download the data set. Try again in a moment.");
        })
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>
